<!-- 角色管理 -->
<template>
  <div class="role-manage">
    <div class="table-header">
      <a-form :layout="'horizontal'" class="page-search" :colon="true">
        <a-row :gutter="20">
          <a-col span="6">
            <a-form-item
              label="角色名称"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <InputText
                placeholder="请输入"
                v-model="params.roleName"
                allowClear
              />
            </a-form-item>
          </a-col>
          <a-col span="6">
            <a-form-item
              label="授权应用"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <SelectModule
                v-model="params.appId"
                apiType="getAllAppInfo"
                autoValue="id"
                autoLabel="appShortName"
                @change="handleChange"
              />
              <!-- <InputText
                placeholder="请输入"
                v-model="params.appShortName"
                allowClear
              /> -->
              <!-- <LenovoSelectModule
                :reset="true"
                placeholder="请输入"
                v-model="params.appShortName"
                apiType="getAllAppInfo"
                modelKey="appShortName"
                :paramsListObj="{ name: 'appShortName', id: 'id' }"
              /> -->
            </a-form-item>
          </a-col>
          <a-col span="6">
            <a-form-item
              label="状态"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <SelectModule
                v-model="params.roleStatus"
                apiType="getDictDataByCode"
                :apiParams="{ dictCode: 'role_status' }"
              />
            </a-form-item>
          </a-col>

          <a-col class="flag" span="6">
            <a-button @click="onReset"
              ><a-icon type="reload" style="color: #585d68" />重置</a-button
            >
            <a-button type="primary" @click="handleSearch"
              ><IconSvg iconData="search" />查询</a-button
            >
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-concent">
      <div class="concent-buts">
        <a-button type="primary" @click="handleTableRow(true, {}, '1')"
          ><a-icon type="plus" />新增</a-button
        >
      </div>
      <TableList
        :columns="columns"
        :tableData="tableData"
        :loading="loading"
        :pageInfo="pageBean"
        @getList="changePage"
      >
        <div slot="action" slot-scope="record" class="columns-action">
          <a-button type="link" @click="handleTableRow(true, record.scope, '3')"
            >查看</a-button
          >
          <a-button type="link" @click="handleTableRow(true, record.scope, '2')"
            >编辑</a-button
          >
          <a-button type="link" @click="showSendConfirm(record.scope)">{{
            record.scope.roleStatus == "0" ? "停用" : "启用"
          }}</a-button>
          <a-button type="link" @click="showDeletConfirm(record.scope)"
            >删除</a-button
          >
        </div>
      </TableList>
    </div>
    <AddEdit
      :modalFlag="modalFlag"
      :modalType="modalType"
      :modalData="modalData"
      @handleFlag="handleTableRow"
    />
  </div>
</template>

<script>
import InputText from "@/components/form/InputText"; // 输入框组件
import SelectModule from "@/components/form/SelectModule"; // 下拉组件
import TableList from "@/components/table/TableList"; // 表格组件
import LenovoSelectModule from "@/components/form/LenovoSelectModule"; // 联想下拉
import AddEdit from "./components/AddEdit.vue";
import API from "@/api/sysManage.js"; // 请求接口
import moment from "moment";

import "./index.less";

export default {
  components: {
    InputText,
    SelectModule,
    TableList,
    LenovoSelectModule,
    AddEdit
  },
  computed: {
    columns() {
      const columns = [
        {
          title: "序号",
          dataIndex: "key",
          key: "key",
          width: 100,
          align: "center",
          fixed: "left",
          ellipsis: true,
          customRender: (text, row, index) => {
            return (
              (this.pageBean.pageNum - 1) * this.pageBean.pageSize + index + 1
            );
          },
        },
        {
          title: "角色名称",
          dataIndex: "roleName",
          key: "roleName",
          ellipsis: true,
        },
        {
          title: "授权应用",
          dataIndex: "appShortName",
          key: "appShortName",
          ellipsis: true,
          scopedSlots: { customRender: "appShortName" },
        },
        {
          title: "状态",
          dataIndex: "roleStatusDesc",
          key: "roleStatusDesc",
          ellipsis: true,
        },
        {
          title: "操作",
          dataIndex: "actions",
          key: "actions",
          width: 200,
          align: "center",
          fixed: "right",
          scopedSlots: { customRender: "action" },
        },
      ];
      return columns;
    },
  },
  data() {
    return {
      loading: false, // 是否加载
      pageBean: {
        // 自定义分页
        pageNum: 1, // 当前页数
        pageSize: 10, // 每页条数
        total: 0, // 数据总数
      },
      params: {
        roleName: "", // 角色名称
        appId: "", // 授权app简称id
        // appShortName: "", // 授权app简称
        roleStatus: "", // 角色状态
      },
      dateValue: [], // 日期
      tableData: [], // 列表数据
      formItemLayout: {
        labelCol: {
          span: 6,
        },
        wrapperCol: {
          span: 18,
        },
      },
      modalFlag: false, // 弹层状态
      modalType: "", // 弹层类型
      modalData: {}, // 表格选中数据
    };
  },
  mounted() {
    this.handleSearch();
  },
  methods: {
    moment,
    onChange(date, dateString) {
      this.dateValue = dateString;
    },
    // 选择授权应用name
    handleChange(id, option) {
      // this.params.appShortName = option.name;
    },
    // 查询
    handleSearch() {
      this.getData(1);
    },
    // 获取列表数据
    getData(pageNum) {
      this.loading = true;
      let params = {
        data: {
          pageBean: {
            pageNum: pageNum,
            pageSize: this.pageBean.pageSize,
          },
          params: {
            ...this.params,
            startDate:
              this.dateValue && this.dateValue.length > 0
                ? this.dateValue[0]
                : "",
            endDate:
              this.dateValue && this.dateValue.length > 0
                ? this.dateValue[1]
                : "",
          },
        },
      };
      API.loadRoles(params, (callback) => {
        this.loading = false;
        let list = []; // 数据
        if (callback.status == "S" && callback.data) {
          const backData = callback.data;
          const pageBean = { ...this.pageBean };
          pageBean.total = backData.total || 0;
          pageBean.pageNum = pageNum || 1;
          this.pageBean = pageBean;

          if (Array.isArray(backData.list) && backData.list.length > 0) {
            backData.list.map((item, index) => {
              // item.key = item.id;
              item.key = index;
            });
            list = backData.list;
          }
          this.tableData = list;
        }
      });
    },
    // 分页事件
    changePage(page, filters, sorter) {
      this.pageBean.pageNum = page.current || 1;
      this.pageBean.pageSize = page.pageSize || 10;
      this.getData(this.pageBean.pageNum);
    },
    // 重置
    onReset() {
      this.params = {
        roleName: "", // 角色名称
        appId: "", // 授权app简称id
        // appShortName: "", // 授权app简称
        roleStatus: "", // 角色状态
      };
      this.handleSearch();
    },
    // 查看详情
    handleTableRow(flag, row, type, status) {
      this.modalFlag = flag;
      this.modalData = row || {};
      this.modalType = type;
      if (status == "ok") {
        this.getData(1);
      }
    },
    // 删除
    showDeletConfirm(row) {
      let _this = this;
      this.$confirm({
        title: "是否确定删除当前的角色?",
        content: (h) => <div style=""></div>,
        onOk() {
          const params = {
            data: {
              params: {
                id: row.id,
              },
            },
          };
          API.deleteRoleById(params, (callback) => {
            if (callback.status == "S") {
              _this.$message.destroy();
              _this.$message.success("删除成功");
              _this.handleSearch();
            }
          });
        },
        onCancel() {
          console.log("Cancel");
        },
        class: "test",
      });
    },
    // 发布/撤回
    showSendConfirm(row) {
      let _this = this;
      this.$confirm({
        title: `是否确定${
          row.roleStatus == "0" ? "停用" : "启用"
        }当前的角色?`,
        content: (h) => <div style=""></div>,
        onOk() {
          const params = {
            data: {
              params: {
                id: row.id,
                roleStatus: row.roleStatus == "0" ? "1" : "0",
              },
            },
          };
          API.updateRoleStatus(params, (callback) => {
            if (callback.status == "S") {
              _this.$message.destroy();
              _this.$message.success(
                `${row.roleStatus == "0" ? "停用" : "启用"}成功`
              );
              _this.handleSearch();
            }
          });
        },
        onCancel() {
          console.log("Cancel");
        },
        class: "test",
      });
    },
  },
};
</script>
